import React from 'react';
import MainLayoutHome from '../layout/MainLayoutHome';
import Bluette from '../components/Bluette';

const BluettePage = () => {
  return (
    <MainLayoutHome>
        <Bluette/>
    </MainLayoutHome>
  )
}

export default BluettePage